/** Client-side title cleanup (keeps parity with backend humanize_opportunity_title). */

export function humanizeOpportunityTitle(name) {
  if (name == null) return name;
  const s = String(name).trim();
  if (!s) return s;
  const m = s.match(/^(AI-Powered|AI-Driven|AI-Based|AI-Enabled)\s+/i);
  let rest = s;
  if (m) {
    rest = s.slice(m[0].length).trim();
  } else if (/^ai\s+/i.test(s)) {
    rest = s.replace(/^ai\s+/i, "").trim();
  } else if (/^ai[-:]+\s*/i.test(s)) {
    rest = s.replace(/^ai[-:]+\s*/i, "").trim();
  }
  if (rest && rest !== s) {
    return rest.length > 1 ? rest.charAt(0).toUpperCase() + rest.slice(1) : rest.toUpperCase();
  }
  return s;
}
